import type React from "react";
import { Redirect, Route, type RouteComponentProps, type RouteProps } from "react-router-dom";

export interface AppRouteProps extends RouteProps {
  token?: string;
  publicRoute?: boolean;
  redirectPath?: string;
  component: React.FC<RouteComponentProps>;
}

interface Options {
  pathname: string;
  search?: string;
}

interface Location {
  hash: string;
  pathname: string;
  search: string;
  state: string;
}

const redirect = (path: string, location: Location) => {
  let options: Options = { pathname: path };
  if (location) {
    options = {
      ...options,
      search: location.pathname !== "/idp-logout" ? `?state=${location.pathname}` : location.search,
    };
  }
  return <Redirect to={options} />;
};

const AppRoute: React.FC<AppRouteProps> = ({
  component: Component,
  redirectPath = "",
  token,
  publicRoute,
  ...rest
}) => {
  if (publicRoute) {
    return <Route {...rest} render={(props) => <Component {...props} />} />;
  }
  return (
    <Route
      {...rest}
      render={(props) =>
        !token ? redirect(redirectPath, props.location as Location) : <Component {...props} />
      }
    />
  );
};

export default AppRoute;
